import { Button } from '@repo/shadcn';
import { Link } from 'react-router-dom';

import { PlusIcon } from '@/assets/svg.icons/icons';

import { useRolePermission } from './role-permission.hook';

function RoleListHeadingActions() {
    const { onOpenChange } = useRolePermission();
    return (
        <div className="flex gap-4">
            <Button onClick={onOpenChange}>
                <PlusIcon />
                New Role & Permissions
            </Button>
            <Link to={'/users'}>
                <Button>
                    <PlusIcon />
                    Users
                </Button>
            </Link>
        </div>
    );
}

export default RoleListHeadingActions;
